import { ReactComponent as LogOut } from './log-out.svg'

export default LogOut
